import React from 'react';
import { Content, Row, Col } from 'components';
import { Button, Descriptions, Flex, Input } from 'antd';

const DEFAULT_VALUE = {
  advance_price_description: '-',
  contract_date_description: '-',
  mandatory_usage_date_description: '-',
  management_description: '-',
  additional_cost_description: '-',
};

const SalesInformation_rentalExplanation = ({ defaultData, onChange }) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const [isEdit, setIsEdit] = React.useState(false);
  const [description, setDescription] = React.useState(DEFAULT_VALUE);
  //   const [restValue, setRestValue] = React.useState(null);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  const handleChange = (t, v) => {
    setDescription((prev) => ({
      ...prev,
      [t]: v,
    }));
  };

  const handleEditing = () => {
    if (isEdit) {
      onChange({
        // ...restValue,
        ...description,
      });
      setIsEdit(!isEdit);
    } else {
      setIsEdit(!isEdit);
    }
  };

  /**--------------------
   * 타이틀
   * --------------------
   */
  const handleGetTitle = (v) => {
    switch (v) {
      case 'contract_date_description':
        return '계약기간';
      case 'mandatory_usage_date_description':
        return '의무사용기간';
      case 'advance_price_description':
        return '선 납입금';
      case 'management_description':
        return '관리유형';
      case 'additional_cost_description':
      default:
        return '추가비용';
    }
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  React.useEffect(() => {
    if (!defaultData) {
      return;
    }

    const {
      advance_price_description,
      contract_date_description,
      mandatory_usage_date_description,
      management_description,
      additional_cost_description,
      //   ...rest
    } = defaultData;

    // setRestValue(rest);
    setDescription({
      advance_price_description,
      contract_date_description,
      mandatory_usage_date_description,
      management_description,
      additional_cost_description,
    });
  }, [defaultData]);

  /* ===== Render ===== */
  return (
    <Content style={{ width: '100%', maxWidth: '100%' }}>
      <Row>
        <Col x={24}>
          <Flex justify="flex-end">
            <Button type="primary" onClick={() => handleEditing()}>
              {isEdit ? '저장' : '수정'}
            </Button>
          </Flex>
          <Descriptions
            items={Object.entries(description).map(([key, value]) => ({
              key: key,
              label: handleGetTitle(key),
              children: isEdit ? (
                <Input.TextArea
                  value={value}
                  placeholder="설명글을 입력해주세요."
                  onChange={(e) => handleChange(key, e.target.value)}
                />
              ) : (
                value
              ),
            }))}
            column={2}
            bordered
            // labelStyle={{ maxWidth: 150 }}
          />
        </Col>
      </Row>
    </Content>
  );
};
export default SalesInformation_rentalExplanation;
